export default __webpack_public_path__ + "static/media/circle2.201807b9.svg";